<template>
  <v-col cols="6">
    <span class="d-block text--secondary mb-4">
      Profil na
    </span>
    <div class="d-flex align-center">
      <img :src="require(`@/static/${item.name}.png`)" :alt="item.name" />
      <span class="panel-header__name mb-0 ml-3">{{ itemName }}</span>
    </div>
  </v-col>
</template>

<script>
import startCase from "lodash/startCase";

export default {
  name: "ExpansionPanelHeaderSocialMedia",
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    itemName() {
      return startCase(this.item.name);
    }
  }
};
</script>

<style lang="scss" scoped>
.panel-header__name {
  font-size: 18px;
}
</style>
